import React from 'react';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import { useWaypointTemplateQuery } from '@dashboard/generated/wp/platform';
import { Divider, Menu } from '@mui/material';

import ArchiveTemplateButton from './ArchiveTemplateButton';
import DuplicateTemplateAsLayoutButton from './DuplicateTemplateAsLayoutButton';
import DuplicateTemplateButton from './DuplicateTemplateButton';
import TemplateActivityLink from './TemplateActivityLink';

type Props = {
  redirect?: boolean;
  templateId: string;
  anchorEl: null | HTMLElement;
  setAnchorEl: (el: null | HTMLElement) => void;
};

export default function TemplateActionsMenu({ redirect, anchorEl, setAnchorEl, templateId }: Props) {
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Menu anchorEl={anchorEl} open={anchorEl !== null} onClose={handleClose}>
      <MenuContent {...{ redirect, handleClose, templateId }} />
    </Menu>
  );
}

type ContentProps = {
  redirect?: Props['redirect'];
  templateId: Props['templateId'];
  handleClose: () => void;
};
function MenuContent({ redirect, templateId, handleClose }: ContentProps) {
  const { data } = useWaypointTemplateQuery({ variables: { id: templateId } });

  const templateType = data?.WaypointTemplate.type;
  if (!templateType) {
    return <LoadingIndicator />;
  }
  if (templateType === 'LAYOUT') {
    return (
      <>
        <DuplicateTemplateButton onClose={handleClose} id={templateId} type="LAYOUT" />
        <ArchiveTemplateButton redirect={redirect} onClose={handleClose} id={templateId} />
      </>
    );
  }

  return (
    <>
      <TemplateActivityLink id={templateId} />
      <Divider />
      <DuplicateTemplateButton onClose={handleClose} id={templateId} type="TEMPLATE" />
      <DuplicateTemplateAsLayoutButton onClose={handleClose} id={templateId} />
      <Divider />
      <ArchiveTemplateButton redirect={redirect} onClose={handleClose} id={templateId} />
    </>
  );
}
